import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const TrackHeader = memo(function TrackHeader({
  title,
  description,
  enabled,
  onToggle,
  disabled,
}: {
  title: string;
  description?: string;
  enabled: boolean;
  onToggle: (value: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <Flex align="center" justify="space-between" pb="lg">
      <Flex dir="column">
        <Text fontSize="xl" fontWeight="semibold" textColor="primary">
          {title}
        </Text>
        {description && (
          <Text fontSize="xs" textColor="tertiary">
            {description}
          </Text>
        )}
      </Flex>
      <Flex align="center" gap="md">
        <Text
          fontSize="xs"
          fontWeight="semibold"
          textColor={enabled ? "primary" : "tertiary"}
        >
          {enabled ? "On" : "Off"}
        </Text>
        <RedoToggle
          disabled={disabled}
          setValue={onToggle}
          size="sm"
          value={enabled}
        />
      </Flex>
    </Flex>
  );
});
